import { getConfig } from '@amzn/aws-howser-client-config';
import AWSConciergeMagicMovieMachine from '@amzn/awsconcierge-magic-movie-machine-type-script-client';

class ServiceProvider {
  static getHowserService(): AWSConciergeMagicMovieMachine {
    const howserServiceConfig = getConfig('howserService');
    return new AWSConciergeMagicMovieMachine({ endpoint: howserServiceConfig?.endpoint });
  }
}

export default ServiceProvider;
